import React, { useCallback, useEffect } from 'react';
import i18n from '../../Shared/Translation/i18n.js';
import InputCont from '../../Shared/Form/InputCont.js';
import useDetail from '../../Shared/useDetail/index.js';
import { ApiUrl } from '../../project/Defines.js';
import { dispatchCustomEvent, EVENT_NAME } from '../../project/utilities.js';

export default function Screens({requireSSO}) {
    const listUpdateEvent = EVENT_NAME.SALES_NETWORK_SCREEN_LIST_UPDATE;
    const reloadEvent = EVENT_NAME.SALES_NETWORK_SCREEN_LIST_LOAD;

    const { dataItem, setDataItem, updateData, validation } = useDetail({
        data: {},
        dataLoadParams: {requireSSO: requireSSO},
        updateUrl: ApiUrl.SalesNetworkConfigUpdate,
        dataLoadUrl: ApiUrl.ThercodimSalesNetworkScreensLoad,
        listUpdateEvent,
        reloadEvent
    });

    useEffect( () => {
        if(dataItem !== null) {
            dispatchCustomEvent(reloadEvent, { action: 'update' });
        }
    },[requireSSO]); // eslint-disable-line react-hooks/exhaustive-deps

    const updateSuccessCallback = useCallback(() => {
        return true;
    }, []);

    const dataChange = (e) => {
        const newData = {...dataItem, item: {...dataItem.item, [e.target.name]: e.target.checked}};

        updateData(updateSuccessCallback, null, { overrideData: { name: e.target.name, value: e.target.checked} });

        setDataItem(newData);
    }

    return <>{dataItem &&
        <div className="section_group">
        <div className="sections extra">
            <div className="form_fields"><div className="section_title"><text>{i18n("text.screen_display")}</text></div><div className="form_separator"></div></div>
            <div className="form_fields">{
                dataItem && Object.keys(dataItem.item).map(key => (
                    <cont key={key}>
                        <InputCont
                            key={key}
                            label={`text.${key}`}
                            inputProps={{
                                validation, name: key, type: 'checkbox', value: dataItem.item[key], onChange: (e) => { dataChange(e) },
                                checked: dataItem.item[key]
                            }} />
                    </cont>
                ))
            }
            </div>
        </div>
    </div>
    }
    </>
}